import * as React from "react";
const SvgClockin = (props) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 10, viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L9 1L9 9", stroke: "#0F64D5", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgClockin;
